<template>
    <div>
        <div v-if="pconUrl !== ''" class="single__intro-wrapper position-relative">
            <iframe style="width: 100%; height: 80vh"
                    :src="pconUrl"
                    frameborder="0"
                    ref="iframe"
                    @load="onIframeLoad">
            </iframe>
            <div v-if="isProcessing" class="pcon-loader__wrapper">
                <div class="pcon-loader__content">
                    <div class="text" v-html="text"></div>
                    <div class="loader"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ExceptionMap from "ceres/app/exceptions/ExceptionMap";
import { isNullOrUndefined } from "ceres/app/helper/utils";

export default {
    props: {
        isPreview: {
            type: Boolean,
            default: false
        }
    },

    inject: {
        itemId: {
            default: null
        }
    },

    data() {
        return {
            isProcessing: false,
            text: 'Ihr individueller Artikel wird erstellt'
        }
    },

    computed: {
        currentVariation() {
            return this.$store.getters[`${this.itemId}/currentItemVariation`]
        },
        pconUrl() {
            let part1 = ""
            for (let key in this.currentVariation.variationProperties) {
                for (let key2 in this.currentVariation.variationProperties[key].properties) {
                    if (this.currentVariation.variationProperties[key].properties[key2].id === 255) {
                        part1 = this.currentVariation.variationProperties[key].properties[key2].values.value;
                    }
                }
            }
            if (part1 === "") {
                return "";
            } else if (this.isPreview) {
                return "https://ui.pcon-solutions.com/#GATEKEEPER_ID=65e6c3945d3b2&moc=NARFC&ban=DJT101&sid=QACTIVE&ovc=MG2012.FrameAndLegColour%3DA%3BMG2012.Columns%3D333%3BMG2012.MetalFeet%3DF%3BMG2012.PowerPlug%3DEU%3BMG2012.Button%3DUA&lang=de&sp=true&HOOK_URL=https://wbconnect.de/plenty/set-variation/10359";
            } else {
                return part1 + this.itemId + '?mode=v2';
            }
        }
    },

    created() {
        document.addEventListener("pcon-add-to-basket", this.pconAddToBasket)
    },
    beforeDestroy() {
        document.removeEventListener("pcon-add-to-basket", this.pconAddToBasket)
    },

    methods: {
        pconAddToBasket(data) {
            let that = this;
            that.text = 'Ihr individueller Artikel wird in den Warenkorb gelegt'

            let timeout = 10000;
            if (!isNullOrUndefined(data.detail.created) && data.detail.created === 'false') {
                timeout = 1;
            }

            window.setTimeout(() => {
                that.addToBasket(parseInt(data.detail.variationId), data.detail.quantity)
            }, timeout);
        },

        addToBasket(id, qty) {
            this.$store.dispatch("loadComponent", "add-item-to-basket-overlay");
            this.$store.dispatch("loadComponent", "basket-preview");

            this.$store.commit("setIsAddToBasketLoading", id);

            const basketObject = {
                variationId: id,
                quantity: qty
            };
            this.$store.dispatch("addBasketItem", basketObject).then(response => {
                $('#pcon').modal("hide");
                document.dispatchEvent(new CustomEvent("afterBasketItemAdded", {detail: basketObject}));
                this.$store.commit("setIsAddToBasketLoading", 0);

                setTimeout(() => {
                    this.$refs.iframe.src = this.pconUrl;
                    this.isProcessing = false;
                }, 1000)

            }, error => {
                this.$store.commit("setIsAddToBasketLoading", 0);

                if (error.data) {
                    NotificationService.error(
                        this.$translate(
                            "Ceres::Template." + ExceptionMap.get(error.data.exceptionCode.toString()),
                            error.data.placeholder
                        )
                    ).closeAfter(5000);
                }

                setTimeout(() => {
                    this.$refs.iframe.src = this.pconUrl;
                    this.isProcessing = false;
                }, 1000)
            });
        },

        onIframeLoad() {
            window.addEventListener("message", this.handleIframeMessage);
        },

        handleIframeMessage(event) {
            if (event.origin !== "https://ui.pcon-solutions.com") return;

            if (!isNullOrUndefined(event.data.data) && event.data.data.type === "sendOCI") {
                this.isProcessing = true
            }
        }
    },
}
</script>
